import VIEWPORTS from '../plugins/viewports'
import PARTSLOADER from '../plugins/partsloader'
import CONTENT_TITLE from '../plugins/contentTitle'

// スクロールして画面エリアに入ったら要素を表示する lazydisp
import LAZYDISP from '../plugins/lazydisp'

// IEでのpictureタグ対応
import IE_SRCSET from '../plugins/polyfill-ie-srcset'

// IE11でSVGの外部参照を有効にする
import 'svgxuse'

export default function INIT() {

  IE_SRCSET();
  
  /*****
   * Promise
   */
  window.load = {
    'header': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'contentFooter': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'footer': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'mapScript': new $.Deferred, // googlemapAPIのURLパラメータでresolveします
  }

  VIEWPORTS() // Viewportの置き換え

  LAZYDISP('[data-lazydisp]') // lazydisp実行 使い方は`/less/component/lazydisp.less`を参照
  
  //header.html, footer.html読み込み
  PARTSLOADER([
    {
      name: 'footer',
      loadhtml: '/asset/html/footer.html?ts=20221221',
      target: 'footer #footerNav',
      method:'replaceWith',
      callback(r,_){
        $('#allbox').append( `<div class="p-gotop__wrap hidden hidden-small-up">
        <a href="#pagetop" class="p-gotop">TOP</a>
      </div>` );
      }
    },
    {
      name: 'contentFooter',
      loadhtml: '/asset/html/contentFooter.html?ts=20221221',
      target: 'footer,#footer.ui-footer',
      method:'before',
      callback(r,_){
        $('.homeContentslist').insertBefore('#footer');
      }
    },
    {
      name: 'header',
      loadhtml: '/asset/html/header.html?ts=20221221',
      target: 'header',
      method:'replaceWith',
      callback(r,_){
        $('header .p-gnav').currentMenu({mode:1,default:999});
        $('header .p-gnav__subnav').currentMenu({mode:0,default:999});
        $('header .p-gnav__item').each( function(){
          const $indicator = $(`<a href="javascript:void(0);" class="p-gnav__item__indicator">`)
          if( this.querySelectorAll('.p-gnav__subnav-list').length ){
            $(this).append( $indicator )
          }
          $(this).find('.p-gnav__subnav-list').slideUp();
          $indicator.on('click', ()=>{
            $(this).find('.p-gnav__subnav-list').slideToggle()
            $indicator.toggleClass('is-active')
          })
        })
      }
    }
  ])
  // DOM Ready
  $(() => {
    // <body>にクラス付与
    $.bodyClass();
    // htmlデータ読み込み
    $('[data-load-html]').loadHtml();
    // カレントメニュー
    $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});
    // ページングテキスト
    $.pagingText({
      prev:'Prev',
      next:'Next',
      list:'List'
    })
    // ページトップリンクをスクロール量で表示するサンプル
    $.scrollspy({
      trigger:200,
      onBefore(/* pos */) {
        $('.p-gotop__wrap').addClass('hidden');
      },
      onAfter() {
        $('.p-gotop__wrap').removeClass('hidden');
      }
    })
  })

  // window.load['contentFooter'].done(() => {
  //   // fullcalendar挿入
  //   FULLCALENDAR(document.querySelectorAll('[data-plugin="calendar"]'),{
  //     googleCalendarApiKey: 'AIzaSyAp7Q8UGPJkuCJnRnq4M9PZgilB1XTkVQM',
  //     contentHeight: 500,
  //     eventSources: [
  //       {
  //         googleCalendarId: 'japanese__ja@holiday.calendar.google.com',
  //         className: 'holiday'
  //       }
  //     ]
  //   })
  // })

}